import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CommandContribution, CommandRegistry } from '@patsnap/tahiti-core';
import { ShareLinkDialogService, type ShareLinkDialogOptions } from '../share-link-dialog-service';

/**
 * 分享链接命令选项
 */
export interface ShareLinkCommandOptions {
    /**
     * 密码保护（可选）
     */
    password?: string;
}

/**
 * 分享链接命令贡献
 */
@injectable()
export class ShareLinkCommandContribution implements CommandContribution {
    constructor(
        @inject(ShareLinkDialogService)
        private readonly _shareLinkDialogService: ShareLinkDialogService,
    ) {}

    /**
     * 处理分享链接命令
     * @param options - 分享链接选项
     */
    private async _handleShareLink(options?: ShareLinkCommandOptions): Promise<void> {
        // 打开分享对话框 - 传递 password
        const dialogOptions: ShareLinkDialogOptions = {
            password: options?.password,
        };

        await this._shareLinkDialogService.open(dialogOptions);
    }

    /**
     * 注册命令
     * @param commands - 命令注册器
     */
    registerCommands(commands: CommandRegistry): void {
        // 注册打开分享对话框命令
        commands.registerCommand({
            id: 'share-link:open',
        }, {
            execute: async (options?: ShareLinkCommandOptions) => {
                await this._handleShareLink(options);
            },
        });
    }
}

/**
 * 扩展 CommandService 类型定义
 */
declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 打开分享链接对话框
         * @param commandId - 命令ID
         * @param options - 分享链接选项
         */
        executeCommand(commandId: 'share-link:open', options?: ShareLinkCommandOptions): Promise<void>;
    }
}
